<template>
  <div class="listBox">
    <ul class="sBox">
      <li style="flex: 1">
        <el-input
          v-model="state.params.Params.Key"
          style="width: 15%"
          placeholder="搜索抬头名称或纳税人识别号"
          clearable
          @clear="
            delete state.params.Params.Key;
            onLoad();
          "
        ></el-input>
        <el-select
          v-model="state.params.Params.GlLx"
          placeholder="关联对象"
          clearable
          style="width: 10%; margin-left: 10px"
          @change="onLoad()"
        >
          <el-option label="客户" value="kh"></el-option>
          <el-option label="游客" value="yk"></el-option>
          <el-option label="员工" value="yh"></el-option>
        </el-select>
        <el-select
          v-model="state.params.Params.Lx"
          placeholder="抬头类型"
          clearable
          style="width: 10%; margin-left: 10px"
          @change="onLoad()"
        >
          <el-option label="个人" :value="1"></el-option>
          <el-option label="企业" :value="2"></el-option>
        </el-select>
        <el-select
          v-model="state.params.Params.IsMr"
          placeholder="是否默认"
          clearable
          style="width: 10%; margin-left: 10px"
          @change="onLoad()"
        >
          <el-option label="是" :value="true"></el-option>
          <el-option label="否" :value="false"></el-option>
        </el-select>
        <el-dropdown
          split-button
          @click="onLoad()"
          type="primary"
          style="margin-left: 10px"
        >
          查询
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                重置
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </li>
      <li style="display: flex; align-items: center">
        <el-button
          type="primary"
          icon="Plus"
          link
          @click="onOpenCompile()"
        >
          添加发票抬头
        </el-button>
      </li>
    </ul>
    <ul class="tBox">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.Order,
          order: state.params.Asc == false ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="#"
          width="50"
          type="index"
          :index="
            (index) =>
              (state.params.PageIndex - 1) * state.params.PageSize + index + 1
          "
          align="center"
        />
        <el-table-column prop="IsQy" sortable="IsQy" label="状态" align="center" width="80">
          <template #default="{ row }">
            <el-tag v-if="row.IsQy" type="success" size="small">启用</el-tag>
            <el-tag v-else type="danger" size="small">停用</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="IsMr" label="默认" align="center" width="80">
          <template #default="{ row }">
            <el-tag v-if="row.IsMr" type="warning" size="small">默认</el-tag>
            <span v-else style="color: #999">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="Lx" sortable="Lx" label="类型" align="center" width="100">
          <template #default="{ row }">
            <el-tag v-if="row.Lx == 1" type="info" size="small">个人</el-tag>
            <el-tag v-else type="primary" size="small">企业</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="GlLx" label="关联对象" align="center" width="100">
          <template #default="{ row }">
            <el-tag v-if="row.KhId" type="success" size="small">客户</el-tag>
            <el-tag v-else-if="row.YkId" type="warning" size="small">游客</el-tag>
            <el-tag v-else-if="row.YhId" type="primary" size="small">员工</el-tag>
            <el-tag v-else type="info" size="small">系统</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="GlMc" label="关联名称" width="180">
          <template #default="{ row }">
            <span v-if="row.KhMc">{{ row.KhMc }}</span>
            <span v-else-if="row.YkXm">{{ row.YkXm }}({{ row.YkSjhm }})</span>
            <span v-else-if="row.YhXm">{{ row.YhXm }}</span>
            <span v-else style="color: #999">-</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="Mc"
          sortable="Mc"
          label="发票抬头名称"
          min-width="180"
          :formatter="
            (row, column, cellValue) =>
              $tab_Highlinght(cellValue, state.params.Params.Key)
          "
        />
        <el-table-column
          prop="Nsrsbh"
          label="纳税人识别号"
          min-width="150"
          :formatter="
            (row, column, cellValue) =>
              $tab_Highlinght(cellValue, state.params.Params.Key)
          "
        />
        <el-table-column prop="Dwdz" label="单位地址" min-width="150" />
        <el-table-column prop="Dwdh" label="单位电话" width="120" />
        <el-table-column prop="Khyh" label="开户银行" width="120" />
        <el-table-column prop="Yhzh" label="银行账号" width="150" />
        <el-table-column
          prop="Cjsj"
          sortable="Cjsj"
          label="创建信息"
          width="160"
          :formatter="(row) => $tab_GroupFormat(row.CjrXm, row.Cjsj)"
        />
        <el-table-column
          label="操作"
          width="280"
          align="center"
          fixed="right"
          className="tabBtn"
        >
          <template #default="{ row }">
            <el-button
              type="warning"
              :icon="Star"
              link
              @click="onSetDefault(row.Id)"
              v-if="!row.IsMr"
            >
              设为默认
            </el-button>
            <el-button
              type="primary"
              :icon="Edit"
              link
              @click="onOpenCompile(row.Id)"
            >
              编辑
            </el-button>
            <el-button
              type="danger"
              :icon="Delete"
              link
              @click="onDelete(row.Id)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.PageIndex"
        @onLoad="
          (pageIndex) => {
            state.params.PageIndex = pageIndex;
            onLoad();
          }
        "
      >
      </c_page>
    </ul>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showCompile"
        :title="state.compileTitle + '发票抬头'"
        @close="onCloseCompile(false)"
      >
        <c_compile
          @close="onCloseCompile(true)"
          :id="state.selectId"
        ></c_compile>
      </c_popup>
    </transition>
  </div>
</template>

<script>
import { getCurrentInstance, onMounted, reactive } from "vue";
import {
  fapiaotoutai_list,
  fapiaotoutai_delete,
  fapiaotoutai_setdefault,
} from "@/http/api";

import c_compile from "./Compile.vue";

export default {
  components: {
    c_compile,
  },
  setup() {
    const { proxy } = getCurrentInstance();
    const state = reactive({
      params: {
        PageSize: 20,
        PageIndex: 1,
        Params: {},
        Order: "Id",
        Asc: false,
      },
    });

    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;
      fapiaotoutai_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //打开内容页
    const onOpenCompile = (id) => {
      state.compileTitle = id ? "修改" : "添加";
      state.selectId = id;
      state.showCompile = true;
    };

    //关闭内容页
    const onCloseCompile = (refresh) => {
      state.showCompile = false;
      if (refresh) {
        onLoad();
      }
    };

    //排序
    const onSortChange = (column) => {
      state.params.Order = column.prop;
      state.params.Asc = column.order === "ascending";
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, {
        params: {
          PageSize: 20,
          PageIndex: 1,
          Params: {},
          Order: "Id",
          Asc: false,
        },
      });
      onLoad();
    };

    //删除
    const onDelete = (id) => {
      proxy.$confirm_func(fapiaotoutai_delete, id, onLoad);
    };

    //设置默认
    const onSetDefault = (id) => {
      proxy.$confirm_func(
        fapiaotoutai_setdefault,
        id,
        onLoad,
        "确定要将此发票抬头设为默认吗？"
      );
    };

    return {
      state,
      onLoad,
      onSortChange,
      onReset,
      onDelete,
      onSetDefault,
      onOpenCompile,
      onCloseCompile,
    };
  },
};
</script>
<style scoped></style>